import { AirplaneIcon, BuildingsIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import PageError from "@/components/Errors/PageError";

interface OfferNotAvailableErrorProps {
  variant: "flight" | "hotel";
}

export const OfferNotAvailableError = ({
  variant,
}: OfferNotAvailableErrorProps) => {
  const intl = useIntl();
  const Icon = variant === "flight" ? AirplaneIcon : BuildingsIcon;

  return (
    <PageError
      title={
        variant === "flight"
          ? intl.formatMessage({
              defaultMessage: "This flight offer is not available anymore",
              description:
                "Error heading when the selected flight offer has expired",
            })
          : intl.formatMessage({
              defaultMessage: "This hotel offer is not available anymore",
              description:
                "Error heading when the selected hotel offer has expired",
            })
      }
      subtitles={[
        variant === "flight"
          ? intl.formatMessage({
              defaultMessage:
                "Unfortunately, this flight offer is not available anymore. Please try again later or choose another flight.",
              description:
                "Explanation that the selected flight offer is no longer available",
            })
          : intl.formatMessage({
              defaultMessage:
                "Unfortunately, this hotel offer is not available anymore. Please try again later or choose another hotel.",
              description:
                "Explanation that the selected hotel offer is no longer available",
            }),
      ]}
      back={{
        text: intl.formatMessage({
          defaultMessage: "Back to search",
          description:
            "Button to return to search when the selected offer has expired or is unavailable",
        }),
        options: {
          to: variant === "flight" ? "/flights/departure/list" : "/hotels/list",
        },
      }}
      icon={<Icon size={60} color="var(--color-text-interactive)" />}
    />
  );
};
